import React from "react"
import StocksFooter from "../footer/StocksFooter"
import CustomPermissions from "../permissions/CustomPermissions"
import CustomTitle from "../title/CustomTitle"

function StocksConsent({ id, rrn, ticket, consents, redirect }) {
  const StocksTitle = <CustomTitle merchantName={ticket.tp.name} />
  const StocksPermissions = (
    <CustomPermissions sharedInformation={ticket.tp.sharedInformation} />
  )
  return (
    <>
      {StocksTitle}
      <div className="container-flex">{StocksPermissions}</div>
      <StocksFooter id={id} rrn={rrn} opt={consents} redirect={redirect} />
    </>
  )
}

export default StocksConsent
